export default "__VITE_ASSET__CtUV9vgY__"